import React from 'react';

export const ListItem = (props) => {
  let list = props.list;
  let eventHandler = props.action;
  return (
    list &&
    list.map((items, index) => (
      <a key={index} id={items.Description} data={JSON.stringify(items)} onClick={(e) => eventHandler(this, items)}>
        {items.Description ? items.Description : items.BranchName}
      </a>
    ))
  );
};
